import React, { useEffect, useRef } from 'react';
import './VideoPlayer.css';

const VideoPlayer = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Function to start playing when any user interaction happens
    const attemptPlay = () => {
      if (videoRef.current) {
        videoRef.current.play().catch(error => {
          // Silently handle the error - we'll try again on next interaction
          console.log("Video autoplay prevented, waiting for interaction");
        });
      }
    };

    // Intersection Observer to play video when in viewport
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && videoRef.current) {
          attemptPlay();
        } else if (videoRef.current) {
          videoRef.current.pause();
        }
      });
    }, options);

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    // Cleanup function
    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);

  return (
    <section id="video-application" className="video-player-section">
      <div className="container">
        <h2 className="section-title">Video Application</h2>
        <div className="video-player-container">
          <div className="video-glow"></div>
          <video 
            ref={videoRef}
            src="/assets/Video.mp4" 
            controls 
            className="full-video"
            playsInline
            preload="auto"
          ></video>
        </div>
      </div>
    </section>
  );
};

export default VideoPlayer; 